/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const BookmarkRegularV6 = (props) => (
  <Icon {...props} name="Bookmark Regular V6">
    <path d="M12.5 0h-9A1.5 1.5 0 0 0 2 1.5v13.497a1 1 0 0 0 1.504.864L8 13.238l4.497 2.623c.666.362 1.503-.092 1.503-.863V1.501a1.5 1.5 0 0 0-1.5-1.5zm0 14.125L8 11.5l-4.5 2.625V1.687c0-.105.082-.188.159-.188h8.625c.134 0 .216.082.216.188v12.438z" />
  </Icon>
);

export default BookmarkRegularV6;
